export const themeApp = {
  palette: {
    primary: {
      main: "#294181", // Blue
      contrastText: "#fff",
    },
    blue: {
      main: "#13345F", // Pink
      contrastText: "#fff", // White text on secondary color
    },
    error: {
      main: "#f44336", // Red
    },
    warning: {
      main: "#ff9800", // Orange
    },
    info: {
      main: "#2196f3", // Light Blue
    },
    success: {
      main: "#4caf50", // Green
    },
    customColor: {
      text: "#000000",
      background: "#ffffff",
      primary: "#294181",
      blue: "#13345F",
      gray: "#8C8C8C",
      black: "#000000",
      yellow: "#F6821F",
      main: "#000000",
    },
  },
};
